import { sygnet } from './sygnet'
import { logo } from './logo'
import { logoNegative } from './logo-negative'

import {
  cilApplicationsSettings,
  cilSpeedometer,
  cilSun,
	cilMoon,
  cilBullhorn,
  cilContact,
  cilUser,
  cilCloudUpload,
} from '@coreui/icons'

export const icons = Object.assign({}, {
  sygnet,
  logo,
  logoNegative
}, {
  cilApplicationsSettings,
  cilSpeedometer,
  cilSun,
  cilMoon,
  cilContact,
  cilBullhorn,
  cilUser,
  cilCloudUpload,
})
